import React, { useState } from 'react';
import Banner from './Banner';
import './HomeScreen.css';
import Nav from './Nav';
import Navbar from './Navbar';
import Footer from './Footer/Footer';
import KipCards from './Cards/KipCards';
import AboutUs from './About/AboutUs';
import MapWithDescription from './Maps/MapWithDescription';
import Product from './Maps/Product';
import Population from './Maps/Population';
import Agriculture from './Maps/Agriculture';
import Land from './Maps/Land';
import PopAsal from './Maps/PopAsal';
import Nutrition from './Maps/Nutrition';
import { useNavigate } from 'react-router-dom';


function HomeScreen() {
  const [showLand, setShowLand] = useState(false);

  const handleButtonClick = () => {
    setShowLand(!showLand);
  };

  const navigate = useNavigate();

  return (
    <div className='homescreen'>
      <Nav />
      <Navbar />
      <Banner />
      <KipCards />
      <AboutUs />
      <MapWithDescription />
      <Product />
      <Population />
      <Agriculture />

      <div style={{ marginTop: '10px', marginBottom: '10px' }}>
        <button
          className={`custom-button ${showLand ? 'close' : ''}`}
          onClick={handleButtonClick}
        >
          {showLand ? 'X' : 'See more'}
          {showLand ? null : <span className="arrow">→</span>}
        </button>
      </div>

      {showLand && (
        <div>
          <Land />
          <PopAsal />
          <Nutrition />
        </div>
      )}

      {showLand && (
        <div className='demo_page' style={{ marginTop: '10px', marginBottom: '2px' }}>
          <p
            onClick={() => navigate('/demographics')}
            className="demo__parg" style={{ textAlign: 'left', fontSize: '18px', fontWeight: '600', color: '#009036', marginLeft: '100px', cursor: 'pointer' }}>Click to see more on Demographics</p>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default HomeScreen;
